module.exports = __webpack_public_path__ + "static/media/gmcab-chip-logo.ff270f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gmcab-chip-logo.png
// module id = 479
// module chunks = 0